import { checkMinMax } from './checkMinMax';
import { stringToDate } from './stringToDate';
import { toTimeFormat } from './toTimeFormat';
/* Generate options based on min, max and step */
export const generateOptions = (min, max, step, format) => {
    const filledRangeMinMax = fillDateRange(min, max, step);
    return filledRangeMinMax.map((date) => ({
        text: toTimeFormat(date, format),
        value: date,
    }));
};
/* Return array of Datetime's from min to max, step in munutes */
export const fillDateRange = (min, max, step) => {
    let minTime, maxTime;
    if (stringToDate(min) < stringToDate(max)) {
        minTime = stringToDate(min);
        maxTime = stringToDate(max);
    }
    else {
        minTime = stringToDate(max); // From max to min (reverse)
        maxTime = stringToDate(min);
    }
    const range = [];
    let time = minTime;
    while (checkMinMax(minTime, maxTime, time)) {
        range.push(time);
        time = addMinutes(time, step);
    }
    return range;
};
const addMinutes = (date, minutes) => {
    const d = stringToDate(date);
    return new Date(d.getTime() + minutes * 60000);
};
//# sourceMappingURL=generateOptions.js.map